/**
 * Format a numeric value to exactly 2 decimal places for percentage display.
 * Returns a string like "75.00", "83.33", "100.00".
 */
export function formatPct(value: number | string | null | undefined): string {
  const num = Number(value ?? 0);
  if (isNaN(num)) return '0.00';
  return num.toFixed(2);
}
